'use strict';

const defaultConfig = {
    lazySourceAttr: 'data-videosrc',
    loadSuccessClass: 'lazyloaded',
    clickListenerSelector: '.video-tile',
    deviceTypeAttribute: 'data-device',
    breakPointMobile: 480,
    breakPointTablet: 900
};

const DEVICE = {
    mobile: 'mobile',
    tablet: 'tablet'
}

function isMobile(config=defaultConfig) {
    return window.innerWidth <= config.breakPointMobile;
}
function isTablet(config=defaultConfig) {
    return window.innerWidth <= config.breakPointTablet;
}
function loadVideo(entry, config) {
    if (entry.classList.contains(config.loadSuccessClass)) return;
    const lazysrc = entry.getAttribute(config.lazySourceAttr);
    entry.src = lazysrc;
    entry.classList += ` ${config.loadSuccessClass}`;
    let video = entry.closest('video');
    $(video).on('play pause', () => {
        $(video).toggleClass('playing');
    })
    video.load();
    if(!$(entry).parent().hasClass('video-redirect-element')){
        setTimeout(() => {
            video.play();
        }, 50);
    }
}

exports.init = function (config = defaultConfig) {
    config = Object.assign(defaultConfig, config);

    const elements = document.querySelectorAll(`[${config.lazySourceAttr}]:not(.${config.loadSuccessClass})`);

    elements.forEach(entry => {
        function eventHandler (e) {
            e.preventDefault();
            e.stopPropagation();

            const deviceType = entry.getAttribute(config.deviceTypeAttribute);
            switch (deviceType) {
                case DEVICE.mobile: isMobile(config) && loadVideo(entry, config); break;
                case DEVICE.tablet: isTablet(config) && loadVideo(entry, config); break;
                default: loadVideo(entry, config);
            }

            const eventHolder = entry.closest(config.clickListenerSelector);
            const totalSources = eventHolder.querySelectorAll('source').length;
            const loadedSources = eventHolder.querySelectorAll(`source.${config.loadSuccessClass}`).length;
            (totalSources===loadedSources) && eventHolder.removeEventListener('click', eventHandler);
        }
        entry.closest(config.clickListenerSelector).addEventListener('click', eventHandler);
    });
}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/lazyloadvideo.js